import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { CopyOutlined } from "@ant-design/icons";

export const CopyIconButton = ({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    text && (
      <Tooltip
        className={className}
        title={t("systems.Action.copied")}
        trigger="click"
      >
        <CopyOutlined
          onClick={async () => {
            text && (await navigator.clipboard.writeText(text));
          }}
        />
      </Tooltip>
    )
  );
};
